import React, { useEffect, useState } from 'react';
import { Landmark, Mail, Clock } from 'lucide-react';
import axiosInstance from '../../api/axios';
import { formatEUR } from '../../utils/format';

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString('de-DE') : '—');

const Row = ({ o, onOpen }) => (
  <tr
    className="border-t border-[#EFE6DA] hover:bg-[#FAF5EE] cursor-pointer transition-colors"
    onClick={() => onOpen(o.id)}
    data-testid={`open-transfer-row-${o.id}`}
  >
    <td className="py-2 pr-3 font-medium">#{o.order_number}</td>
    <td className="py-2 pr-3">
      <div>{o.customer_name}</div>
      <div className="text-xs text-gray-500">{o.customer_email}</div>
    </td>
    <td className="py-2 pr-3 font-semibold">{formatEUR(Number(o.total || 0))}</td>
    <td className="py-2 pr-3">
      <span className={`px-2 py-0.5 text-xs ${o.days_open >= 14 ? 'bg-red-100 text-red-800' : o.days_open >= 7 ? 'bg-amber-100 text-amber-800' : 'bg-gray-100 text-gray-700'}`}>
        {o.days_open} {o.days_open === 1 ? 'Tag' : 'Tage'}
      </span>
    </td>
    <td className="py-2 pr-3 text-xs">
      {o.reminder_sent_at ? (
        <span className="inline-flex items-center gap-1 text-green-700"><Mail className="h-3 w-3" />gesendet {fmtDate(o.reminder_sent_at)}</span>
      ) : (
        <span className="inline-flex items-center gap-1 text-gray-500"><Clock className="h-3 w-3" />am {fmtDate(o.reminder_due_at)}</span>
      )}
    </td>
    <td className="py-2 text-xs text-gray-600">{fmtDate(o.auto_cancel_at)}</td>
  </tr>
);

export const OpenTransfersPanel = ({ refreshKey, onOpenOrder }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axiosInstance.get('/bank-transfers/admin/open').then((r) => setData(r.data)).catch(() => setData({ orders: [], count: 0, total_amount: 0 }));
  }, [refreshKey]);

  if (!data) return null;

  return (
    <div className="bg-white border border-[#E8DED1] p-4 mb-6" data-testid="open-transfers-panel">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <h2 className="text-base font-semibold text-gray-700 flex items-center gap-2">
          <Landmark className="h-4 w-4 text-[#8B7355]" />
          Offene Überweisungen
          <span className="text-xs font-normal text-gray-500" data-testid="open-transfers-count">
            ({data.count} · {formatEUR(Number(data.total_amount || 0))})
          </span>
        </h2>
        <p className="text-xs text-gray-500">Automatische Erinnerung nach 7 Tagen · Storno nach 21 Tagen ohne Zahlung</p>
      </div>
      {data.count === 0 ? (
        <p className="text-sm text-gray-500" data-testid="open-transfers-empty">Keine offenen Überweisungen – alles bezahlt.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left">
            <thead className="text-xs uppercase tracking-wide text-gray-500">
              <tr>
                <th className="pb-2 pr-3">Bestellung</th>
                <th className="pb-2 pr-3">Kunde</th>
                <th className="pb-2 pr-3">Betrag</th>
                <th className="pb-2 pr-3">Offen seit</th>
                <th className="pb-2 pr-3">Erinnerung</th>
                <th className="pb-2">Auto-Storno</th>
              </tr>
            </thead>
            <tbody>
              {data.orders.map((o) => <Row key={o.id} o={o} onOpen={onOpenOrder} />)}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
